export class AboutModel {
  id: number;
  title: string;
  body: string;
  type: string;
}
